<template src="./LastJobs.html">

</template>

<script>
import ArrobaMedellinArrobitaNoData from "@/components/ArrobaMedellinArrobitaNoData/ArrobaMedellinArrobitaNoData";
import ArrobaMedellinSeeker from "@/components/ArrobaMedellinSeeker/ArrobaMedellinSeeker";
const {DateTime} = require("luxon");

export default {
  name: "LastJobs",
  props: {
    lastJobs: {
      type: Array
    },
    errorMessage: {
      type: Boolean
    }
  },
  components:{
    ArrobaMedellinArrobitaNoData,
    ArrobaMedellinSeeker
  },
  filters:{
    dateFormat: function (value){
      return DateTime.fromISO(value).toFormat('dd LLLL yyyy ', { locale: "es" })
    }
  },
  computed: {
    enrichedLastJobs() {
      const now = DateTime.local();
      return this.lastJobs.map((offer) => {
        const isExpired = offer.deadline ? DateTime.fromISO(offer.deadline) < now : false;
        const isInactive = offer.isClosed || offer.isFinished || offer.isDeleted;
        let statusLabel = "Activa";
        let statusClass = "status-pill--active";
        if (isInactive) {
          if (isExpired) {
            statusLabel = "Vencida";
            statusClass = "status-pill--expired";
          } else {
            statusLabel = "Cerrada";
            statusClass = "status-pill--closed";
          }
        }
        return {
          ...offer,
          _isExpired: isExpired,
          _statusLabel: statusLabel,
          _statusClass: statusClass
        };
      });
    }
  }
}
</script>

<style scoped lang="scss" src="./LastJobs.scss">

</style>
